export const sdkWrapperURL = (url = "") =>
  new URL(url, "https://analytics-api-portal.carenow.healthcare");
